import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { Trash2 } from "lucide-react";
import { Module } from "@/constants";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { useRowSelectionCount } from "@/components/data-table/hooks/useRowSelectionCount";
import { memo } from "react";

interface StoreProjectAssigneesDeleteSelectedButtonProps {
  onClick: () => void;
}

const StoreProjectAssigneesDeleteSelectedButtonComponent = ({
  onClick,
}: StoreProjectAssigneesDeleteSelectedButtonProps) => {
  const { t } = useTranslation();
  const { can_delete } = useModulePermissions(Module.StoreProjectAssignees);
  const selectedCount = useRowSelectionCount();

  return (
    <Button
      disabled={selectedCount === 0 || !can_delete}
      variant="destructive"
      size="sm"
      onClick={onClick}
    >
      <Trash2 className="w-4 h-4 mr-2" />
      {t("storeProjectAssignees.buttons.deleteSelected")}
    </Button>
  );
};

export const StoreProjectAssigneesDeleteSelectedButton = memo(
  StoreProjectAssigneesDeleteSelectedButtonComponent,
);
